module.exports = {"TXTWCL_24_hour_lockout":{"id":"TXTWCL_24_hour_lockout","defaultMessage":"Bloqueo de 24 horas"}}